// Assign each group a maximally-distinct colour by its index in the given order:
// golden-angle hue spacing (137.5°) spreads N groups around the wheel with the
// largest possible minimum separation. Callers pass ids in DISPLAY order (rows
// top-to-bottom), so consecutive rows land ~137.5° apart and vertically adjacent
// bars never look alike. Order-dependent by design — position drives the hue —
// so a fixed group set (deterministic time sort) still colours the same on every
// render. Returned as a map of inline hsl() values (not Tailwind classes) so any
// number of groups is covered without the purge caring about dynamic class names.
const GOLDEN_ANGLE = 137.508;

export interface GroupColor {
  /** Solid hue for the identity stripe on the bar's first day segment. */
  stripe: string;
  /** Translucent wash for run-day segments — the bar's body colour. */
  runFill: string;
  /** Near-transparent wash for off-day gaps inside a non-contiguous span. */
  offFill: string;
}

export function buildGroupColors(ids: string[]): Map<string, GroupColor> {
  // Dedup while preserving the caller's (display) order — no sort.
  const unique = [...new Set(ids)];
  const colors = new Map<string, GroupColor>();
  unique.forEach((id, index) => {
    const hue = Math.round((index * GOLDEN_ANGLE) % 360);
    colors.set(id, {
      stripe: `hsl(${hue} 70% 58%)`,
      runFill: `hsl(${hue} 70% 58% / 0.14)`,
      offFill: `hsl(${hue} 70% 58% / 0.04)`,
    });
  });
  return colors;
}
